import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { forwardRef } from 'react';

import { panelGridLayoutConfig } from '../../../../../../utils/panelGridLayoutConfig';

import styles from './instrumentPanelDragHandle.module.scss';

export const InstrumentPanelDragHandle = forwardRef<
  HTMLDivElement,
  Record<string, never>
>(function InstrumentPanelDragHandle(
  { style, className, onMouseDown, onMouseUp, onTouchEnd },
  ref,
): JSX.Element {
  return (
    <div
      ref={ref}
      style={style}
      className={classNames(
        styles.drag,
        panelGridLayoutConfig.draggableHandle,
        className,
      )}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <Tooltip
        content="Drag to move"
        side="top"
        wrap="div"
        wrapProps={{ style: { display: 'flex' } }}
      >
        <Icon name="drag" />
      </Tooltip>
    </div>
  );
});
